import { defineAsyncComponent } from 'vue'
export default {
  admin: defineAsyncComponent(() => import("/opt/build/repo/app/layouts/admin.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/opt/build/repo/app/layouts/default.vue").then(m => m.default || m)),
  main: defineAsyncComponent(() => import("/opt/build/repo/app/layouts/main.vue").then(m => m.default || m)),
  simple: defineAsyncComponent(() => import("/opt/build/repo/app/layouts/simple.vue").then(m => m.default || m)),
  starter: defineAsyncComponent(() => import("/opt/build/repo/app/layouts/starter.vue").then(m => m.default || m)),
  unauthenticated: defineAsyncComponent(() => import("/opt/build/repo/app/layouts/unauthenticated.vue").then(m => m.default || m))
}